import { ReactComponent as ClipIcon } from '@/assets/icons/clip-icon.svg'
import { ReactComponent as PaperClipIcon } from '@/assets/icons/paper-clip-icon.svg'
import { ReactComponent as AlignCenter } from '@/assets/icons/editor/align-center.svg'
import { ReactComponent as AlignLeft } from '@/assets/icons/editor/align-left.svg'
import { ReactComponent as AlignRight } from '@/assets/icons/editor/align-right.svg'
import { ReactComponent as AttachHyperlink } from '@/assets/icons/editor/attach-hyperlink.svg'
import { ReactComponent as AttachImage } from '@/assets/icons/editor/attach-image.svg'
import { ReactComponent as BulletedList } from '@/assets/icons/editor/bulleted-list.svg'
import { ReactComponent as FontBold } from '@/assets/icons/editor/font-bold.svg'
import { ReactComponent as FontColor } from '@/assets/icons/editor/font-color.svg'
import { ReactComponent as FontItalic } from '@/assets/icons/editor/font-italic.svg'
import { ReactComponent as FontStrikethrough } from '@/assets/icons/editor/font-strikethrough.svg'
import { ReactComponent as FontUnderline } from '@/assets/icons/editor/font-underline.svg'
import { ReactComponent as NumberedList } from '@/assets/icons/editor/numbered-list.svg'
import { AddAttachmentButton, EditorButton } from '.'
import { useSlate } from 'slate-react'
import editorService from '../editor.service'
import { TwitterPicker } from 'react-color'
import { useEffect, useState } from 'react'
import DraftManagerService from '@/app-domains/messages/draft/service/DraftManager.service'
import { InsertImageButton } from './ImageUpload'
import commonsService from '@/services/commons.service'
import classNames from 'classnames'
import store from '@/core/store'
import {
  Transforms,
  Editor
} from 'slate'

const TEXT_ALIGN_TYPES = ['left', 'center', 'right']

export function EditorToolbar (props) {
  const { parentMessageId } = props
  const [isColorPickerOpen, setIsColorPickerOpen] = useState(false)
  const [isMobileToolbarOpen, setIsMobileToolbarOpen] = useState(false)
  const [isMessageReadyToBeSent, setIsMessageReadyToBeSent] = useState(false)

  const [color, setColor] = useState('#374151')
  const colorOptions = [
    '#9CA3AF',
    '#374151',
    '#FACC15',
    '#4ADE80',
    '#2DD4BF',
    '#3B82F6',
    '#6467F2',
    '#EC4899',
    '#F43F5E',
    '#D946EF',
    '#8B5CF6',
    '#0EA5E9',
    '#10B981',
    '#84CC16',
    '#EF4444',
    '#F97316',
  ]

  const editor = useSlate()

  const BlockButton = ({ children, format }) => {
    const editor = useSlate()
    return (
      <EditorButton
        active={editorService.isBlockActive(editor, format, TEXT_ALIGN_TYPES.includes(format) ? 'align' : 'type')}
        onMouseDown={event => {
          event.preventDefault()
          editorService.toggleBlock(editor, format)
        }}
      >
        {children}
      </EditorButton>
    )
  }
  
  const MarkButton = ({ children, format, color }) => {
    const editor = useSlate()
    return (
      <EditorButton
        active={editorService.isMarkActive(editor, format)}
        onMouseDown={event => {
          if (color) {
            setIsColorPickerOpen(!isColorPickerOpen)
            colorPickerListener()
            window.slateSelection = editor.selection
            return
          }
          event.preventDefault()
          editorService.toggleMark(editor, format, color)
        }}
      >
        {children}
      </EditorButton>
    )
  }

  const colorPickerListener = () => {
    const closeColorPicker = (e) => {
      if (!document.querySelector('.color-picker')?.contains(e?.target)) {
        setIsColorPickerOpen(false)
        window.removeEventListener('click', closeColorPicker)
      }
    }
    window.addEventListener('click', closeColorPicker)
  }

  const closeToolbarIfTappedOutside = (e) => {
    const toolbarElement = document.querySelector('.mobile-editor-toolbar')
    if (toolbarElement && !toolbarElement.contains(e.target)) {
      setIsMobileToolbarOpen(false)
    }
  }

  const toggleMobileToolbar = (e) => {
    e.preventDefault()
    e.stopPropagation()
    // const { top, height } = document.querySelector('.action-bar-section').getBoundingClientRect()
    // setMobileToolbarPosition({ top: `${top - (height - 20)}px` })
    setIsMobileToolbarOpen(!isMobileToolbarOpen)
    if (!isMobileToolbarOpen) {
      editorService.focusEditor(editor)
      window.addEventListener('click', closeToolbarIfTappedOutside)
    } else {
      window.removeEventListener('click', closeToolbarIfTappedOutside)
    }
  }

  const sendMessage = () => {
    DraftManagerService.sendMessageInstantly(parentMessageId || undefined)
  }

  useEffect(() => {
    store.on('DRAFT_MESSAGE:READY_TO_SEND', (payload) => {
      setIsMessageReadyToBeSent(payload)
    })

    const currentDraft = DraftManagerService.getCurrentDraftMessageFromStore()

    if (DraftManagerService.isDraftReadyToBeSent(currentDraft)) {
      setIsMessageReadyToBeSent(true)
    }
  }, [])

  const ColorButton = () => {
    return <MarkButton format="color" color={color}>
      <div className="action">
        <FontColor color={color} />
      </div>
    </MarkButton>
  }

  const setHexColor = (color) => {
    setColor(color.hex)
    // setIsColorPickerOpen(!isColorPickerOpen)
    document.querySelector('.editable-slate-element').focus()
    Transforms.select(editor, window.slateSelection || Editor.end(editor, []))
    editorService.toggleMark(editor, 'color', color)
    window.slateSelection = null
  }

  if (!commonsService.isMobile()) {
    return (
      <div className='action-bar-section'>
        { isColorPickerOpen &&
        <div className='color-picker'>
          <TwitterPicker
            colors={colorOptions}
            color={color} onChangeComplete={setHexColor} />
        </div>}
        <div className="left-content">
          <div className="action-group">
            <div className="action" style={{ display: 'flex', alignItems: 'center' }} onClick={(e) => {
              e.preventDefault()
              setIsColorPickerOpen(!isColorPickerOpen)
            }}>
              <ColorButton />
            </div>
          </div>
          <div className="left-content-divider"/>
          <div className="action-group">
            <MarkButton format="bold">
              <div className="action">
                <FontBold/>
              </div>
            </MarkButton>
            <MarkButton format="italic">
              <div className="action">
                <FontItalic/>
              </div>
            </MarkButton>
            <MarkButton format="underline">
              <div className="action">
                <FontUnderline/>
              </div>
            </MarkButton>
            <MarkButton format="strikethrough">
              <div className="action">
                <FontStrikethrough/>
              </div>
            </MarkButton>
          </div>
          <div className="left-content-divider"/>
          <div className="action-group">
            <BlockButton format="left">
              <div className="action">
                <AlignLeft/>
              </div>
            </BlockButton>
            <BlockButton format="center">
              <div className="action">
                <AlignCenter/>
              </div>
            </BlockButton>
            <BlockButton format="right">
              <div className="action">
                <AlignRight/>
              </div>
            </BlockButton>
          </div>
          <div className="left-content-divider"/>
          <div className="action-group">
            <BlockButton format="bulleted-list">
              <div className="action">
                <BulletedList/>
              </div>
            </BlockButton>
            <BlockButton format="numbered-list">
              <div className="action">
                <NumberedList/>
              </div>
            </BlockButton>
          </div>
          <div className="left-content-divider"/>
          <div className="action-group">
            <div className="action">
              <InsertImageButton format="bold" isBlockActive={editorService.isBlockActive}>
                <AttachImage/>
              </InsertImageButton>
            </div>
            <BlockButton format="hyperlink">
              <div className="action">
                <AttachHyperlink/>
              </div>
            </BlockButton>
          </div>
        </div>
        <div className="right-content">
          <div className='hoverable-button'>
            <div className="option-button clip">
              <AddAttachmentButton>
                <ClipIcon/>
              </AddAttachmentButton>
            </div>
          </div>
          <button type="submit" className='send-message-button' disabled={!isMessageReadyToBeSent} onClick={sendMessage}>
            <PaperClipIcon />
          </button>
        </div>
      </div>
    )
  }
  return (<>
    <div className='action-bar-section'>
      { isColorPickerOpen &&
      <div className='color-picker'>
        <TwitterPicker color={color} onChangeComplete={setHexColor} />
      </div>}
      <div className="left-content">
        <div className="action-group">
          <div className="action clip">
            <AddAttachmentButton>
              <ClipIcon/>
            </AddAttachmentButton>
          </div>
          { !props.isAndroid && <><div className="action">
            <InsertImageButton format="bold" isBlockActive={editorService.isBlockActive}>
              <AttachImage/>
            </InsertImageButton>
          </div>
            <BlockButton format="hyperlink">
              <div className="action">
                <AttachHyperlink/>
              </div>
            </BlockButton>
          </>}
        </div>
      </div>
      <div className='right-content'>
        {!props.isAndroid && <div className={classNames('text-format-action', { opened: isMobileToolbarOpen })} onClick={toggleMobileToolbar}>
          <span><FontStrikethrough /></span> <span>Text format</span>
        </div> }
      </div>
      { isMobileToolbarOpen && <div className="mobile-editor-toolbar">
        { isColorPickerOpen &&
        <div className='color-picker'>
          <TwitterPicker color={color} onChangeComplete={setHexColor} />
        </div>
    }
        <div className="action-group">
          <div className="action">
            <FontColor onClick={() => {}}/>
          </div>
        </div>
        <div className="left-content-divider"/>
        <div className="action-group">
          <MarkButton format="bold">
            <div className="action">
              <FontBold/>
            </div>
          </MarkButton>
          <MarkButton format="italic">
            <div className="action">
              <FontItalic/>
            </div>
          </MarkButton>
          <MarkButton format="underline">
            <div className="action">
              <FontUnderline/>
            </div>
          </MarkButton>
          <MarkButton format="strikethrough">
            <div className="action">
              <FontStrikethrough/>
            </div>
          </MarkButton>
        </div>
        <div className="left-content-divider"/>
        <div className="action-group">
          <BlockButton format="left">
            <div className="action">
              <AlignLeft/>
            </div>
          </BlockButton>
          <BlockButton format="center">
            <div className="action">
              <AlignCenter/>
            </div>
          </BlockButton>
          <BlockButton format="right">
            <div className="action">
              <AlignRight/>
            </div>
          </BlockButton>
        </div>
        <div className="left-content-divider"/>
        <div className="action-group">
          <BlockButton format="bulleted-list">
            <div className="action">
              <BulletedList/>
            </div>
          </BlockButton>
          <BlockButton format="numbered-list">
            <div className="action">
              <NumberedList/>
            </div>
          </BlockButton>
        </div>
      </div>
    }
    </div>
  </>
  )
}
